module.exports = __webpack_public_path__ + "img/img1.b83e32e1.jpg";